/* jshint esversion: 6 */

import Vue from 'vue';
import VueYandexMetrika from 'vue-yandex-metrika';

// Yandex Metrika
const useYandexMetrika = process.env.VUE_APP_YANDEX_METRIKA_ID !== "";

if (useYandexMetrika) {
    Vue.use(VueYandexMetrika, {
        id: process.env.VUE_APP_YANDEX_METRIKA_ID,
        env: 'production'
    });
}
export const yandexMetrika = {
    name: 'yandex-metrika',

    methods: {
        sendToYandexMetrikaFullRegistration: function() {
            this.$metrika.reachGoal('User-FullRegistration-otc');
        },
        sendToYandexMetrikaRegistration: function() {
            this.$metrika.reachGoal('User-Registration-otc');
        },
        sendToYandexMetrikaRegistrationFromSupplierFinder: function() {
            this.$metrika.reachGoal('t_tender-registration');
        },
        sendToYandexMetrikaAuthorizationFromSupplierFinder: function() {
            this.$metrika.reachGoal('t_tender-authorization');
        },
        sendToYandexMetrikaShow: function(widgetData) {
            this.sendToYandexMetrika('showMagnet', widgetData);
        },
        sendToYandexMetrikaToConfirm: function(widgetData) {
            widgetData.state = 1; // ConfirmationAwaiting = 1
            this.sendToYandexMetrika('clickMagnet', widgetData);
        },
        sendToYandexMetrikaToWork: function(widgetData) {
            widgetData.state = 2; // Work = 2
            this.sendToYandexMetrika('clickMagnet', widgetData);
        },
        sendToYandexMetrika: function(targetName, widgetData) {
            if (!useYandexMetrika || !this.$metrika) return;

            const params = {
                touchPointType:     widgetData && widgetData.touchPointInfo ? widgetData.touchPointInfo.type : null,
                touchPointCode:     widgetData && widgetData.touchPointInfo ? widgetData.touchPointInfo.code : null,
                touchPointItemCode: widgetData && widgetData.touchPointInfo ? widgetData.touchPointInfo.itemCode : null,
                targetCode:         widgetData ? widgetData.targetCode : null,
                magnetInfoId:       widgetData ? widgetData.magnetInfoId : null,
                state:              widgetData ? widgetData.state : null,
                createdOn:          new Date()
            };

            this.$metrika.reachGoal(targetName, params);
        }
    }
};